import React from "react";
import Hero from "@/components/Hero";
import FaqJsonLd from "@/components/FaqJsonLd";
import {
  TrustStrip,
  ProblemSolution,
  AIEngine,
  ServicesGrid,
  HotRolesSection,
  RoadmapSection,
  TestimonialsSection,
  FAQSection,
  FinalCTA,
} from "@/components/Sections";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <FaqJsonLd />
      <Hero />
      <TrustStrip />
      <ProblemSolution />
      <AIEngine />
      <ServicesGrid />
      <HotRolesSection />
      <RoadmapSection />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTA />
    </main>
  );
}
